import { createReduxStore, combineReducers, register } from '@wordpress/data';
import { controlAction, controlReducer, controlSelector, demoReducer, demoAction, pluginAction, demoSelector, pluginSelector, pluginReducer, dashboardReducer, dashboardAction, dashboardSelector, templateAction, templateSelector, templateReducer } from './dashboard';

export const store = createReduxStore('jkit/dashboard', {
    reducer: combineReducers({
        modal: dashboardReducer,
        demo: demoReducer,
        plugin: pluginReducer,
        control: controlReducer,
        template: templateReducer
    }),
    actions: {
        ...dashboardAction,
        ...demoAction,
        ...pluginAction,
        ...controlAction,
        ...templateAction
    },
    selectors: {
        ...dashboardSelector,
        ...demoSelector,
        ...pluginSelector,
        ...controlSelector,
        ...templateSelector
    }
});

register(store);